import Vue from 'vue'
import Router from 'vue-router'
import HomeNew from "./v1/views/HomeNew";


Vue.use(Router);

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
      { path: '/', component: HomeNew, },
      { path: '/black-friday-sale', component: () => import (/* webpackChunkName: "black_friday" */'./v1/views/BlackFriday.vue')},
      { path: '/noutbuki', component: () => import (/* webpackChunkName: "noutbuki" */'./v1/views/Home.vue')},
      { path: '/noutbukitest', component: () => import (/* webpackChunkName: "noutbuki" */'./v1/views/HomeTest.vue')},
      { path: '/about', component: () => import (/* webpackChunkName: "about" */'./v1/views/company/About')},
      { path: '/sitemap.txt', component: () => import (/* webpackChunkName: "sitemap" */'./v1/views/sitemap')},
      { path: '/lowest-price', component: () => import (/* webpackChunkName: "lowest-price" */'./v1/views/company/BestPriceGuarantee')},
      { path: '/contacts', component: () => import (/* webpackChunkName: "contacts" */'./v1/views/company/Contacts') },
      { path: '/awaiting', component: () => import (/* webpackChunkName: "awaiting" */'./v1/views/products/ProductsAwaiting')},
      { path: '/sale', component: () => import (/* webpackChunkName: "sale" */'./v1/views/products/ProductsOnSale')},
      { path: '/laptops', component: () => import (/* webpackChunkName: "laptops" */'./v1/views/products/Filters'), props: true },
      { path: '/categories/:type-:category_id', component: () => import (/* webpackChunkName: "laptop-type" */'./v1/views/products/ProductsByType2'), props: true},
      { path: '/search/:keyword', component: () => import(/* webpackChunkName: "search" */'./v1/views/products/ProductsBySearch'), props: true},
      // Version 2
      { path: '/v2', component: () => import(/* webpackChunkName: "v2-homepage" */'./v2/views/Home')},
      { path: '/:category_slug/:product_slug', component: () => import(/* webpackChunkName: "v2-laptop-details-page" */'./v2/views/products/details/ComputerDetails'), props: true},
      { path: '/categories/:type-:category_id/:product_id-:slug', component: () => import (/* webpackChunkName: "laptop-type" */'./v1/views/products/Details2'), props: true},
      { path: '/:brand/:slug/:id', component: () => import (/* webpackChunkName: "laptop-page" */'./v1/views/products/Details'), props: true },
      { path: '/:brand_slug-produkti', component: () => import (/* webpackChunkName: "laptop-by-manufacturer" */'./v1/views/products/ProductsByManufacturer2'), props: true},
      { path: '/:brand_slug-noutbuki', component: () => import (/* webpackChunkName: "laptop-by-manufacturer" */'./v1/views/products/ProductsByManufacturer'), props: true},

      { path: '/:type', component: () => import (/* webpackChunkName: "laptop-type" */'./v1/views/products/ProductsByType'), props: true},
      { path: '/tags/:perk', component: () => import (/* webpackChunkName: "tags" */'./v1/views/products/ProductsByPerks2'), props: true},
      { path: '/cart', component: () => import (/* webpackChunkName: "cart" */'./v1/views/Cart'), props: true },
      { path: '/register', component: () => import (/* webpackChunkName: "register" */'./v1/views/users/Register') },
      { path: '/404', component: () => import (/* webpackChunkName: "404" */'./v1/views/NotFound.vue') },
  ]
})